import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { MatStepper } from '@angular/material/stepper';
import { BusinessUser } from 'src/app/models/business-user.model';
import { Router } from '@angular/router';
import { MgService } from 'src/app/services/mg.service';
import { Observable } from 'rxjs';
import { Call } from 'src/app/models/call.model';

@Component({
  selector: 'app-call-form-operator',
  templateUrl: './call-form-operator.component.html',
  styleUrls: ['./call-form-operator.component.scss']
})
export class CallFormOperatorComponent implements OnInit {
  @ViewChild('stepper') private myStepper: MatStepper;

  public isLinear = false;
  public firstFormGroup: UntypedFormGroup;
  public secondFormGroup: UntypedFormGroup;
  public thirdFormGroup: UntypedFormGroup;
  public business: BasicRegister;
  public userBusiness: BusinessUser;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private api: MgService,
  ) {}

  ngOnInit() {
    this.firstFormGroup = this.fb.group({
      business: [undefined, Validators.required]
    });
    this.secondFormGroup = this.fb.group({
      userBusiness: [undefined, Validators.required]
    });
    this.thirdFormGroup =  this.fb.group({
      description: [null, Validators.required],
      type: ['I', Validators.required],
      priority: ['B', Validators.required],
    });
  }

  public businessSelected(value: BasicRegister) {
    this.business = value;
    if (value) {
      this.firstFormGroup.controls.business.setValue(value.id);
      this.myStepper.next();
    } else {
      this.firstFormGroup.controls.business.setValue(null);
    }
  }

  public userBusinessSelected(value: BusinessUser) {
    this.userBusiness = value;
    this.secondFormGroup.controls.userBusiness.setValue(value.id);
    this.myStepper.next();
  }

  public descriptionHasChanged(value: string){
    this.thirdFormGroup.controls.description.setValue(value);
  }

  public typeHasChanged(value: string){
    this.thirdFormGroup.controls.type.setValue(value);
  }

  public priorityHasChanged(value: string){
    this.thirdFormGroup.controls.priority.setValue(value);
  }

  public get statusNamed() : string {
    switch (this.thirdFormGroup.value.type) {
      case "D": return "Defeito";
      case "P": return "Problema";
      case "A": return "Solicitação de Alteração";
      default: case "I": return "Incidente";
    }
  }

  public get priorityNamed() : string {
    switch (this.thirdFormGroup.value.priority) {
      case "M": return "Média";
      case "A": return "Alta";
      case "U": return "Urgente";
      default: case "I": return "Baixa";
    }
  }

  public get descriptionReady() : boolean {
    return this.thirdFormGroup.value.description != null
  }

  public confirmCall() {
    let call: any = {
      business: this.firstFormGroup.value.business,
      business_user: this.secondFormGroup.value.userBusiness,
      description: this.thirdFormGroup.value.description,
      priority: this.thirdFormGroup.value.priority,
      type: this.thirdFormGroup.value.type,
    };

    this.api.postCall(call)
      .toPromise()
      .catch(err => console.error(err));

    this.toBack()
  }

  public cancelCall() {
    this.newCall()
    this.router.navigate(['/operador/chamados'])
  }

  public newCall() {
    this.business = null;
    this.userBusiness = null;
    this.myStepper.reset();
  }

  public toBack(){
    history.back();
  }
}
